<template>
    <div class="historico-beneficiarios px-4">
        <div class="table-container">
            <div class="ml-3 p-0 d-flex justify-content-between align-items-baseline">
                <b-form-checkbox @input="selecionarTodas" value="true">Selecionar todas</b-form-checkbox>
                <b-button pill class="btn-base primary-btn optum-bold" @click="modalExcluirLinhas">Excluir linhas</b-button>
            </div>
            <b-table id="historico-beneficiarios-temp" striped responsive :items="rows" :fields="headerFields">
                <template v-slot:cell(id.line)="{ item }">
                    <p >
                        <b-form-checkbox v-model="checkedLines" :id="`row_${item.id.line}`" :value="item.id.line"/>
                    </p>
                </template>
                <template v-slot:cell(errors)="{ item }">
                    {{extractFieldErrors(item.errors)}}
                </template>
                <template v-slot:cell(id)="{ item }">
                    <ButtonContainer>
                        <ButtonEditTable :id="item.id.line" titleTooltip="Editar" @click="edit(item)"/>
                        <ButtonRemoveUserTable :id="item.id.line" titleTooltip="Excluir" @click="remove(item)"/>
                        <ButtonViewLogTable :id="item.id.line" titleTooltip="Visualizar Log" @click="rowErrorsId = item"/>
                    </ButtonContainer>
                </template>
            </b-table>
        </div>

        <ModalCorrigirErrosInesperadosForm :importacaoId="rowEditionId.importacaoId" :line="rowEditionId.line" 
		v-if="rowEditionId" @close="rowEditionId = null" @updated="updateHandler" />

        <ModalCorrigirErrorsInesperadosLog v-if="rowErrorsId" :row="rowErrorsId" @closeErrors="closeErrors" />

        <b-modal id="excluir-linha-importacao" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Deseja remover o beneficiário?
			<template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="$bvModal.hide('excluir-linha-importacao')">Não</b-button>
                <b-button pill class="btn-base primary-btn" @click="excluirLinha">Sim</b-button>
            </template>	
        </b-modal>

        <b-modal id="excluir-multiplas-linhas-importacao" centered hide-header
        header-class="deletar-perfil-sub-header" body-class="deletar-perfil-body">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Tem certeza que deseja excluir as linha(s) selecionada(s)?
			<template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="$bvModal.hide('excluir-multiplas-linhas-importacao')">Não</b-button>
                <b-button pill class="btn-base primary-btn" @click="excluirLinhas">Sim</b-button>
            </template>	
        </b-modal>

    </div>
</template>

<script>

let headerFields = [
  //  {key: 'importacaoId', label: "Importação ID"},
    {key: "id.line", label: ""},
    {key: 'linha', label: "Linha"},
    {key: 'nome', label: 'Nome', thStyle: { width: "45%" }},
    {key: 'cpf', label: 'CPF'},
    {key: 'tipo', label: 'Tipo'},
    {key: 'cnpjFaturamento', label: 'CNPJ de Faturamento'},
    {key: 'errors', label: 'Erros'},
    {key: 'id', label: 'Ações'},
]

let columnsKeys = [
    //'importacaoId',
    "id.line",
    'linha',
    'nome',
    'cpf',
    'tipo',
    'cnpjFaturamento',
    'errors',
    'status',
    'id'
]

import ButtonContainer from "@/components/commons/table/components/ButtonContainer.vue";
import ButtonEditTable from "@/components/commons/table/components/ButtonEditTable.vue";
import ButtonViewLogTable from "@/components/commons/table/components/ButtonViewLogTable.vue";
import ButtonRemoveUserTable from "@/components/commons/table/components/ButtonRemoveUserTable.vue";
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import ModalCorrigirErrosInesperadosForm from './ModalCorrigirErrosInesperadosForm'
import ModalCorrigirErrorsInesperadosLog from './ModalCorrigirErrorsInesperadosLog'

export default {
    name: "CorrigirErrosInesperadosList",
    components:{
      ModalCorrigirErrosInesperadosForm,
      ModalCorrigirErrorsInesperadosLog,
      ButtonContainer,
      ButtonViewLogTable,
      ButtonRemoveUserTable,
      ButtonEditTable,
      DynamicIcon,
    },
    props: {
		rows: Array
	},
    data() {
        return {
            TITULAR : 1,
            beneficiario: null,
            acao: null,
            modal: null,
            modalInativar: null,
            rowEditionId: null,
            rowErrorsId: null,
            headerFields: [
                ...headerFields.filter(head => columnsKeys.includes(head.key)),
            ],
            lastFilter: {},
            page: 1,
            checkedLines: [],
        }

    },
    methods:{
        getLabel(key) {
			const result = headerFields.find(field => field.key == key)
			if(result)
				return result.label
		},
        filtrar()
        {
            this.$emit("filter-errors-inesperados", {} )
        },
        edit(beneficiario) {
            this.rowEditionId = beneficiario.id
        },
        remove(beneficiario) {
            this.$bvModal.show("excluir-linha-importacao")
            this.beneficiario = beneficiario
        },
        excluirLinha() {
            if(this.beneficiario == null)
                return
                
            BeneficiarioImportacaoResource.deleteLineImportacao(this.beneficiario.id.importacaoId, this.beneficiario.id.line, {showLoader: true})
			.then(() => {
				this.$bvModal.hide('excluir-linha-importacao') 
                this.filtrar()
			})
        },
        updateHandler() {
			this.rowEditionId = null
			this.filtrar()
		},
        closeErrors() {
            this.rowErrorsId = null
        },
        extractFieldErrors( data ) {
            data = JSON.parse(data); // Converte a string em um objeto JavaScript

            if (data && data.fieldErrors) {
                let result = [];
                for(let elem in data.fieldErrors ) {
                    let label = this.getLabel(elem)
                    if(label)
                        result.push(label+ " obrigatório")
                }
                return result.join("; ");
            } else {
                return [];
            }
        },
        modalExcluirLinhas() {
			this.$bvModal.show('excluir-multiplas-linhas-importacao')
		},
		excluirLinhas() {
			let importacaoId = this.rows[0].id.importacaoId;
			BeneficiarioImportacaoResource.deleteLinesImportacao(importacaoId, this.checkedLines, {showLoader: true})
			.then(() => {
				this.checkedLines = [];
				this.$bvModal.hide('excluir-multiplas-linhas-importacao') 
				this.filtrar(this.lastFilter)
			})
		},
		selecionarTodas(value) {
			this.checkedLines = [];
			if(value)
				this.rows.map(row => this.checkedLines.push(row.id.line))
		}
    }
}
</script>